{
  "body.hello": "Hallo,",
  "body.hello_name": "Hallo {name},",
  "body.footer": "Diese Nachricht stammt von Cargofollow. Antworten auf diese Nachricht werden nicht gelesen.",
  "subject.sign_request": "Unterschrift angefordert für Sendung {reference}",
  "body.sign_request.intro": "{organization} bittet Sie, den Frachtbrief der Sendung {reference} als {role} zu unterschreiben.",
  "body.sign_request.action": "Öffnen Sie diesen Link, um zu unterschreiben: {url}",
  "body.sign_request.expires": "Der Link bleibt bis {expires} gültig und funktioniert einmal.",
  "body.sign_request.ignore": "Sie kennen diese Anfrage nicht? Dann können Sie diese Nachricht ignorieren.",
  "sms.sign_request": "{organization}: Frachtbrief der Sendung {reference} unterschreiben: {url}",
  "subject.otp": "Ihr Cargofollow-Bestätigungscode",
  "body.otp.intro": "Ihr Bestätigungscode lautet {code}.",
  "body.otp.expires": "Der Code bleibt {minutes} Minuten gültig und funktioniert einmal.",
  "body.otp.ignore": "Sie haben keinen Code angefordert? Geben Sie ihn an niemanden weiter und ignorieren Sie diese Nachricht.",
  "sms.otp": "{code} ist Ihr Cargofollow-Bestätigungscode. {minutes} Minuten gültig; geben Sie ihn an niemanden weiter.",
  "subject.pod_delivered": "Ablieferbeleg verfügbar für Sendung {reference}",
  "body.pod_delivered.intro": "Sendung {reference} wurde am {delivered_at} zugestellt und von {signer} unterschrieben.",
  "body.pod_delivered.remarks": "Der Empfänger hat die Güter unter Vorbehalt übernommen.",
  "body.pod_delivered.no_remarks": "Die Güter wurden ohne Vorbehalt übernommen.",
  "body.pod_delivered.action": "Ablieferbeleg ansehen: {url}",
  "subject.authority_access": "Eine Behörde hat Sendung {reference} abgerufen",
  "body.authority_access.intro": "Am {accessed_at} hat eine zuständige Behörde die eFTI-Daten der Sendung {reference} über Gate {gate} abgerufen.",
  "body.authority_access.intro_no_gate": "Am {accessed_at} hat eine zuständige Behörde die eFTI-Daten der Sendung {reference} abgerufen.",
  "body.authority_access.subsets": "Geltend gemachte Rechtsgrundlagen: {subsets}. Übermittelt wurden ausschließlich die Daten, die zu diesen Grundlagen gehören.",
  "body.authority_access.action": "Sendung und vollständige Chronik ansehen: {url}",
  "body.authority_access.webhook": "Sie erhalten diese Nachricht per E-Mail, weil kein Webhook-Endpunkt auf efti.authority_access hört. Richten Sie einen ein, um die Meldung direkt in Ihrem eigenen System zu empfangen.",
  "subject.invite": "Einladung zu {organization} bei Cargofollow",
  "body.invite.intro": "{inviter} lädt Sie ein, {organization} in der Cargofollow-Konsole als {role} beizutreten.",
  "body.invite.action": "Öffnen Sie diesen Link, um die Einladung anzunehmen: {url}",
  "body.invite.expires": "Die Einladung bleibt 48 Stunden gültig.",
  "body.invite.ignore": "Sie kennen diese Einladung nicht? Dann können Sie diese E-Mail ignorieren.",
  "subject.live_request": "Live-Anfrage von {organization}",
  "body.live_request.intro": "{requester} ({email}) beantragt Live-Zugang für {organization}.",
  "body.live_request.organization": "Organisations-ID: {id}",
  "body.live_request.note": "Hinweis: {note}",
  "body.live_request.no_note": "Es wurde kein Hinweis angegeben.",
  "body.live_request.next": "Gehen Sie die Konformitäts-Checkliste durch und aktivieren Sie danach live_enabled.",
  "role.owner": "Eigentümer",
  "role.admin": "Administrator",
  "role.developer": "Entwickler",
  "role.viewer": "Betrachter",
  "role.consignor": "Absender",
  "role.carrier": "Frachtführer",
  "role.consignee": "Empfänger",
  "sms.driver_otp": "{code} ist Ihr Cargofollow-Anmeldecode. Der Code ist {minutes} Minuten gültig. Geben Sie ihn an niemanden weiter."
}
